import { injectable } from "inversify";
import RestApi from "./RestApi";

@injectable()
class HostApi extends RestApi {
}

export default HostApi;

export const HostApiName = "HostApi";